// checkUserFlixHelpId.js
// Leaker detection action
// If user is marked as leaker (by env list), playing flixes in widescreen would crash app.
'use strict';
import { getItem } from '../resource/persist.js';
import markDisturbingAction from '../action/markDisturbingAction.js';

/**
 * Check if user is in flix help id list to toggle help function
 * @kind action
 * @return {Promise} Action promise.
 */
const checkUserFlixHelpId = () => async dispatch => {
  const visitorId = await getItem('_fpIdOpenSource');
  const helpIds = process?.env?.HELP_DISTURB_IDS?.split(',') || [];
  const isNeedHelp = helpIds.includes(visitorId);
  return isNeedHelp
    ? dispatch(markDisturbingAction({ action: 'enable' }))
    : dispatch({ type: '' });
};

export default checkUserFlixHelpId;
